const toTimestamp = item => {
  if (item === '' || item === null) {
    return ''
  } else {
    let arr = item.split('-')
    return String(new Date(parseInt(arr[0]), parseInt(arr[1]) - 1, parseInt(arr[2]) + 1).getTime() / 1000)
  }
}

const fromTimestamp = (timestamp, getDefault = false) => {
  const dateformat = timestamp && String(timestamp).substr(0, 10)
  if (String(dateformat).match(/(....)-(..)-(..)/)) {
    return dateformat
  }
  if (timestamp !== null && timestamp !== '') {
    let date = new Date(timestamp)
    date.setTime(date.getTime() + new Date().getTimezoneOffset() * 60 * 1000)
    // let d = new Date(parseInt(timestamp))
    let month = date.getMonth() <= 8 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    let day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate()
    return `${date.getFullYear()}-${month}-${day}`
  }
  if (getDefault) {
    return getDefault ? window.getYMDDate() : ''
  }
  return timestamp
}

export {
  toTimestamp,
  fromTimestamp
}



// WEBPACK FOOTER //
// ./src/modules/helpers/DateHelpers.js